import { WordTaskGenBase, ThingInfo } from '../genHelper';

export class Math_WordProblem__2A extends WordTaskGenBase {
  name = 'Math.WordProblem__2A';

  constructor() {
    super();
    this.register(this.p1_2a);
    this.register(this.p4_2a);
    this.register(this.p4_1);
    this.register(this.p4_2);
    this.register(this.p5_1a);
    this.register(this.p5_1b);
    this.register(this.p9_1);
    this.register(this.p13_2a);
    this.register(this.p13_2b);
    this.register(this.p21_2a);
    this.register(this.p21_2b);
    this.register(this.p28_2a);
    this.register(this.p28_2b);
    this.register(this.p29_2a);
    this.register(this.p29_2b);
    this.register(this.p36_2a);
    this.register(this.p36_2b);
    this.register(this.p38_2a);
    this.register(this.p38_2b);
    this.register(this.p44_2a);
    this.register(this.p44_2b);
  }

  protected p1_2a = (random: any) => {
    const jm = this.namesPick(random, 2);
    const item1 = this.item(random, 'napsalx', 'vypočítalx', 'přečetlx', 'nakreslilx');
    const num = this.integers(random, 2, 1, 10, (arr) => arr[1] > arr[0]);

    return {
      text: `${jm[0]} ${jm[0].x(item1)} ${num[0]} příkladů. ${jm[1]} ${jm[1].x(item1)} o ${num[1] - num[0]} více.`,
      question: `Kolik příkladů ${jm[1].x(item1)} ${jm[1]}?`,
      result: num[1],
    };
  };

  protected p4_2a = (random: any) => {
    const jm = this.namesPick(random, 2);
    const item1 = this.item(random, 'nasbíralx', 'přineslx', 'koupilx', 'našelx');
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] < arr[1]);

    return {
      text: `${jm[0]} ${jm[0].x(item1)} ${num[1]} hub. ${jm[1]} ${jm[1].x(item1)} o ${num[1] - num[0]} méně.`,
      question: `Kolik hub ${jm[1].x(item1)} ${jm[1]}?`,
      result: num[0],
    };
  };

  protected p44_2a = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 8, (arr) => arr[0] < arr[1]);
    const item1 = this.item(
      random,
      'cestovalx k babičce',
      'cestovalx k dědečkovi',
      'jelx na dovolenou',
      'bylx operován',
      'jelx autem',
      'jelx vlakem'
    );

    return {
      text: `${jm[0]} ${jm[0].x(item1)} ${this.unit.hodinu(num[0])}. ${jm[1]} ${jm[1].x(item1)} ${this.unit.hodinu(num[1])}.`,
      question: `O kolik hodin více ${jm[1].x(item1)} ${jm[1]}?`,
      result: num[1] - num[0],
    };
  };

  protected p4_1 = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] + arr[1] <= 20);
    return {
      text: `${jm[0]} má ${this.unit.korunu(num[0])}. ${jm[1]} má o ${this.unit.korunu(num[1])} více než ${jm[0]}.`,
      question: `Kolik korun má ${jm[1]}?`,
      result: num[0] + num[1],
    };
  };

  protected p4_2 = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] > arr[1]);
    return {
      text: `${jm[0]} má ${this.unit.korunu(num[0])}. ${jm[1]} má o ${this.unit.korunu(num[1])} méně než ${jm[0]}.`,
      question: `Kolik korun má ${jm[1]}?`,
      result: num[0] - num[1],
    };
  };

  protected p5_1a = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] > arr[1]);
    return {
      text: `${jm[0]} má ${this.unit.korunu(num[0])}, ${jm[1]} má ${this.unit.korunu(num[1])}.`,
      question: `O kolik korun má ${jm[0]} více než ${jm[1]}?`,
      result: num[0] - num[1],
    };
  };

  protected p5_1b = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] < arr[1]);
    return {
      text: `${jm[0]} má ${this.unit.korunu(num[0])}, ${jm[1]} má ${this.unit.korunu(num[1])}.`,
      question: `O kolik korun má ${jm[0]} méně než ${jm[1]}?`,
      result: num[1] - num[0],
    };
  };

  protected p9_1 = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => true);
    return {
      text: `${jm[0]} má ${this.unit.korunu(num[0])}, ${jm[1]} má ${this.unit.korunu(num[1])}.`,
      question: `Kdo má více peněz a o kolik?`,
      result: Math.abs(num[0] - num[1]),
    };
  };

  protected p13_2a = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 5, 20, (arr) => arr[0] + arr[1] <= 20);
    const action1 = this.item(random, 'k narozeninám', 'ke svátku', 'k výročí svatby', 'k výročí');
    const item1 = this.item(random, 'růží', 'květin', 'dárků');
    return {
      text: `${jm[0]} ${jm[0].v('dal')} mamince ${action1} ${num[0]} ${item1} a ${jm[1]} ${jm[1].v('daroval')} ${num[1]} ${item1}.`,
      question: `Kolik ${item1} dostala maminka celkem?`,
      result: num[0] + num[1],
    };
  };

  protected p13_2b = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 5, 20, (arr) => arr[0] > arr[1]);
    return {
      text: `${jm[0]} ${jm[0].v('měl')} v peněžence ${this.unit.korunu(num[0])}. ${this.unit.korun(num[1])} si ${jm[1].v('půjčil')} ${jm[1]}.`,
      question: `Kolik korun ${jm[0].v('mu', 'jí')} potom v peněžence zůstalo?`,
      result: num[0] - num[1],
    };
  };

  protected p21_2a = (random: any) => {
    const jm = this.namesPick(random, 1)[0];
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] < arr[1]);
    const item1 = this.item(random, 'zmrzlinu', 'lízátko', 'bonbon', 'žvýkačku', 'Tic-Tac');
    return {
      text: `${jm} má našetřeno ${this.unit.korunu(num[0])} a chce si koupit ${item1} za ${this.unit.korunu(num[1])}.`,
      question: `Kolik korun ${jm.v('mu', 'jí')} chybí?`,
      result: num[1] - num[0],
    };
  };

  protected p21_2b = (random: any) => {
    const jm = this.namesPick(random, 1)[0];
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] + arr[1] <= 20);
    const item1 = this.item(
      random,
      'jablek',
      'hrušek',
      'hroznů',
      'švestek',
      'třešní',
      'ringlí',
      'rybízu',
      'malin',
      'borůvek'
    );
    const item2 = this.item(random, 'tatínek', 'bratr', 'dědeček', 'strýc');
    return {
      text: `${jm} ${jm.v('natrhal')} ${num[0]} kg ${item1}. ${jm.v('Jeho', 'Její')} ${item2} natrhal o ${num[1]} kg více.`,
      question: `Kolik kg ${item1} natrhal ${item2}?`,
      result: num[0] + num[1],
    };
  };

  protected p28_2a = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] + arr[1] <= 20);
    const item = this.item(random, 'moštu', 'vína', 'sirupu', 'vody', 'hroznové šťávy');
    return {
      text: `${jm[0]} si ${jm[0].v('koupil')} ${this.unit.litru(num[0])} ${item}. ${jm[1]} si ${jm[1].v('koupil')} o ${this.unit.litru(num[1])} více.`,
      question: `Kolik litrů ${item} si ${jm[1].v('koupil')} ${jm[1]}?`,
      result: num[0] + num[1],
    };
  };

  protected p28_2b = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] > arr[1]);
    const item = this.item(random, 'moštu', 'vína', 'sirupu', 'vody', 'hroznové šťávy');
    return {
      text: `${jm[0]} ${jm[0].v('zaplatil')} za ${this.unit.litru(1)} ${item} ${this.unit.korunu(num[0])}. ${jm[1]} ${jm[1].v('zaplatil')} za ${this.unit.litru(1)} ${item} ${this.unit.korunu(num[1])}.`,
      question: `O kolik korun méně ${jm[1]} ${jm[1].v('zaplatil')}?`,
      result: num[0] - num[1],
    };
  };

  protected p29_2a = (random: any) => {
    const jm = this.namesPick(random, 1)[0];
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] > arr[1]);
    const action1 = this.item(
      random,
      'dostalx kapesné',
      'vyhrálx',
      'dostalx od babičky',
      'dostalx od dědečka',
      'dostalx od maminky',
      'dostalx od tatínka'
    );
    return {
      text: `${jm} ${jm.x(action1)} ${this.unit.korunu(num[0])}. ${this.unit.korunu(num[1])} ${jm.v('utratil')} a zbytek si ${jm.v('dal')} do pokladničky.`,
      question: `Kolik korun si ${jm} ${jm.v('uspořil')}?`,
      result: num[0] - num[1],
    };
  };

  protected p29_2b = (random: any) => {
    const jm = this.namesPick(random, 1)[0];
    const num = this.integers(random, 2, 5, 18, (arr) => arr[0] < arr[1]);
    const item = this.item(
      random,
      'do školy',
      'k doktorovi',
      'na plavání',
      'na procházku',
      'na výlet',
      'k dědečkovi',
      'k babičce'
    );
    return {
      text: `${jm} ${jm.v('šel', 'šla')} ${item} v ${num[0]} hodin a ${jm.v('vrátil')} se ve ${num[1]} hodin.`,
      question: `Kolik hodin ${jm.v('nebyl')} doma?`,
      result: num[1] - num[0],
    };
  };

  protected p36_2a = (random: any) => {
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] + arr[1] <= 20);
    const array = [
      'ráno',
      'dopoledne',
      'v poledne',
      'odpoledne',
      'k večeru',
      'večer',
      'v noci',
      'o půlnoci',
    ];
    const indexes = [0, 1, 2, 3, 4, 5, 6, 7]
      .sort(() => random.next() - 0.5)
      .slice(0, 2)
      .sort();
    return {
      text: `${this.cap(array[indexes[0]])} byla venku teplota ${num[0]} °C. ${this.cap(array[indexes[1]])} byla teplota venku o ${num[1]} °C vyšší.`,
      question: `Jaká teplota byla ${array[indexes[1]]}?`,
      result: num[0] + num[1],
    };
  };

  protected p36_2b = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num1 = this.integer(random, 4, 8);
    const num2 = this.integer(random, 1, 3);
    const item1 = this.item(random, 'chodí do práce', 'vstává ráno', 'vstává do práce', 'cvičí');
    return {
      text: `${jm[0].text} ${item1} v ${this.unit.hodinu(num1)}. ${jm[1].text} ${item1} o ${this.unit.hodinu(num2)} později.`,
      question: `V kolik hodin ${item1} ${jm[1].text}?`,
      result: num1 + num2,
    };
  };

  protected p38_2a = (random: any) => {
    const jm = this.namesPick(random, 1)[0];
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] > arr[1]);
    const item1 = this.item(random, 'koupilx si', 'pořídilx si', 'zaplatilx za');
    const item2 = this.item(random, 'čaj', 'džus', 'limonádu', 'vodu');
    return {
      text: `${jm} ${jm.v('měl')} ${this.unit.korunu(num[0])} a ${jm.x(item1)} ${item2} za ${this.unit.korunu(num[1])}.`,
      question: `Kolik korun ${jm.v('mu', 'jí')} zbylo?`,
      result: num[0] - num[1],
    };
  };

  protected p38_2b = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 5, 20, (arr) => arr[1] + arr[0] <= 20);
    const item1 = this.item(
      random,
      'jedniček',
      'dvojek',
      'trojek',
      'pětek',
      'poznámek',
      'důtek třídního učitele',
      'pochval'
    );
    return {
      text: `${jm[0]} ${jm[0].v('měl')} v žákovské knížce ${num[0]} ${item1}. ${jm[1]} ${jm[1].v('měl')} o ${num[1]} ${item1} více.`,
      question: `Kolik ${item1} ${jm[1].v('měl')} v žákovské knížce ${jm[1]}?`,
      result: num[0] + num[1],
    };
  };

  protected p44_2b = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integers(random, 2, 1, 20, (arr) => arr[0] + arr[1] <= 20);
    const item1 = this.item(random, 'do školy', 'do práce', 'k lékaři', 'k babičce', 'k dědečkovi');
    return {
      text: `${jm[0]} chodí ${item1} ${this.unit.minutu(num[0] + num[1])}. ${jm[1]} jde ${item1} o ${this.unit.minutu(num[0])} méně.`,
      question: `Kolik minut chodí ${item1} ${jm[1]}?`,
      result: num[1],
    };
  };
}

export class Math_WordProblem__2B extends WordTaskGenBase {
  name = 'Math.WordProblem__2B';

  constructor() {
    super();
    this.register(this.p1_a);
    this.register(this.p3_a);
    this.register(this.p5_3a);
    this.register(this.p5_3b);
  }

  protected p1_a = (random: any) => {
    const num = this.integer(random, 1, 10);
    const item = this.item(random, 'přinesli', 'dali', 'umístili');
    return {
      text: `V naší škole je ${this.unit.any(num, 'okno', 'okna', 'oken')}. Žáci ${item} do každého okna dvě květiny.`,
      question: `Kolik květin žáci ${item} do oken celkem?`,
      result: num * 2,
    };
  };

  protected p3_a = (random: any) => {
    const num = this.integer(random, 1, 10);
    const item = this.item(random, 'hrušky', 'jablka', 'švestky', 'sušenky');
    return {
      text: `Na stole je ${this.unit.any(num, 'talířek', 'talířky', 'talířků')}. Na každý talířek dáme dvě ${item}.`,
      question: `Kolik věcí potřebujeme?`,
      result: num * 2,
    };
  };

  protected p5_3a = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integer(random, 1, 10);
    const thing = this.thing(
      random,
      new ThingInfo('pastelku', 'pastelky', 'pastelek'),
      new ThingInfo('propisku', 'propisky', 'propisek')
    );
    return {
      text: `${jm[0]} ${jm[0].x('mělx')} ${thing.c(num)}. ${jm[1]} ${jm[1].x('mělx')} dvakrát více.`,
      question: `Kolik ${thing.n5p} měla ${jm[1]}?`,
      result: num * 2,
    };
  };

  protected p5_3b = (random: any) => {
    const jm = this.namesPick(random, 2);
    const num = this.integer(random, 1, 10);
    const thing = this.thing(
      random,
      new ThingInfo('pastelku', 'pastelky', 'pastelek'),
      new ThingInfo('propisku', 'propisky', 'propisek')
    );
    return {
      text: `${jm[0]} ${jm[0].x('mělx')} ${thing.c(num)}. ${jm[1]} ${jm[1].x('mělx')} o dva více.`,
      question: `Kolik ${thing.n5p} měla ${jm[1]}?`,
      result: num + 2,
    };
  };
}
